export enum Roles {
  ADMIN = 'ADMIN',
  USER = 'USER',
  PC_ADMIN = 'PC_ADMIN',
  PC_USER = 'PC_USER',
  NO_MODULE_ACCESS = 'NO_MODULE_ACCESS'
}
